import IntersectionObserver from 'intersection-observer-polyfill';

export const initSubNavObserver = () => {
  const subNavSection = document.querySelector(
    '[data-section="works-with-subnav"]'
  );

  const targetEl = document.querySelector(
    '[data-section="works-with-sidebar-filters"]'
  );

  const observer = new IntersectionObserver(callback, { threshold: 0.6 });

  if (targetEl) {
    observer.observe(targetEl);
  }

  function callback(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        subNavSection.setAttribute('data-visible', 'true');
      } else {
        subNavSection.setAttribute('data-visible', 'false');
      }
    });
  }
};
